if (!customElements.get('shop-the-look')) {
	class ShopTheLook extends HTMLElement {
		constructor() {
			super();

			this.addEventListener('click', this.onClick.bind(this))
			this.addEventListener('shopify:block:select', this.onBlockSelect.bind(this))
			this.addEventListener('shopify:block:deselect', this.onBlockDeselect.bind(this))
		}

		get dots() {
			return this.querySelectorAll('.shop-the-look__dot')
		}

		onClick(event) {
			const dot = event.target.closest('.shop-the-look__dot')
			if (dot) this.select(dot, true)
		}

		onBlockSelect(event) {
			const dot = event.target.closest('.shop-the-look__dot')
			if (!dot) return
			this.select(dot, false)
			dot.classList.add('is-editing')
		}

		onBlockDeselect(event) {
			event.target.classList.remove('is-editing')
		}

		select(dot, announce) {
			this.dots.forEach(item => {
				const isSelected = item === dot
				item.classList.toggle('is-active', isSelected)
				item.setAttribute('aria-pressed', isSelected)
			})
			this.querySelectorAll('.shop-the-look__panel').forEach(panel => {
				panel.classList.toggle('is-active', panel.id === dot.dataset.panel)
			})

			const status = this.querySelector('[data-status]')
			if (announce && status && dot.dataset.title) status.textContent = dot.dataset.title
		}
	}
	customElements.define('shop-the-look', ShopTheLook);
}
